import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

interface ChartProps {
    datasetName: string;
    dataset: {
        labels: Array<string>;
        data: Array<number>;
        backgroundColor: Array<string>;
    },
    width?: number;
    height?: number;
    legendDisplay?: boolean;
}
function PieChart({ datasetName, dataset, legendDisplay = true, width = 235, height = 180}: ChartProps) {

    const data = {
        labels: dataset.labels,
        datasets: [
            {
                label: datasetName,
                data: dataset.data,
                backgroundColor: dataset.backgroundColor
            }
        ]
    };

    return (
        <Pie
            data={data}
            width={width}
            height={height}
            options={{
                maintainAspectRatio: false,
                responsive: false,
                plugins: {
                    legend: {
                        display: legendDisplay,
                        align: "center",
                        position: "right"
                    }
                }
            }}
        />
    )
}
export default PieChart